import React from "react";

import { Spinner } from "@samskip/frontend-components";

import { classNames } from "@assets/utilities/classNameUtilities";

interface SpinnerPageProps {
  /** Override or extend the style applied to the component. */
  className?: string;
}
const SpinnerPage = ({ className }: SpinnerPageProps) => {
  return (
    <main className={classNames("flex-grow", className)}>
      <Spinner fullHeight fullWidth />
    </main>
  );
};

export default SpinnerPage;
